module.exports = __webpack_public_path__ + "static/media/Book-Appointment-Icon-Red.d93c00c1.svg";